export default {
  loyalty:
    'Men RC Group hamkorlari <a target="_blank" href="{link}">sadoqat dasturi</a> shartlarini qabul qilaman',
  posOferta:
    'Men RC POS xizmati <a target="_blank" href="https://cdn.rc.today/storage/partners/common/docs/ru/pos/Договор%20о%20присоединении%20к%20RC%20POS.pdf">shartnomasini</a> qabul qilaman',
  1: "Asosiy ma’lumotlar",
  2: "Shaxsiy ma’lumotlar",
  3: "Yuridik shaxs",
  haveAcc: "Hisobingiz bormi?",
  login: "Kirish",

  mainInfo: {
    title: "Asosiy ma’lumotlar",
    promocode: "Promo-kod",
    country: "Mamlakat",
    phone: "Telefon raqami",
    checkbox:
      " Shaxsiy ma’lumotlarimni <a download href='{link}'>Maxfiylik siyosati</a>ga muvofiq qayta ishlashga rozilik beraman",
    oferta:
      "Shartlarni qabul qilaman" + " <a download href='{link}'>Shartnoma</a>",
  },

  profileInfo: {
    title: "Shaxsiy ma’lumotlar",
    firstName: "Ism",
    lastName: "Familiya",
    middleName: "Otasining ismi",
    email: "Elektron pochta",
    password: "Parol",
    confPassword: "Parolni takrorlang",
    registerCode: "Pochtadan kod",
    notSendCode: "Kod kelmadi?",
    sendAgain: "Qayta yuborish",
  },

  emailCode: {
    title: "Tasdiqlash kodi pochtangizga yuborildi",
    subtitle:
      '"{mail}" manziliga xat kelmagan bo‘lsa, «Spam» papkasini tekshiring',
    emailCode: "Pochtadan kod",
    sendAgainTime: "Kod qayta yuborilsin: ",
    dontSend: "Kod kelmadi?",
    sendAgain: "Qayta yuborish",
  },

  entity: {
    title: "Yuridik shaxs",
    subTitle:
      "Iltimos, «Keyingi» tugmasini bosishdan oldin kiritilgan ma’lumotlarni tekshiring",
    entityType: "Yuridik shaxs turi",
    halalCertificate: "Yuridik shaxs Halol sertifikatiga ega",
    fileType: "PNG, JPG, PDF - 1 fayl 10 MB gacha",
    commercial: "Tijorat",
    checkbox: "Yuridik shaxs tadbirkorlik faoliyati bilan shug‘ullanadi",
  },

  payment: {
    title: "Ro‘yxatdan o‘tganingiz uchun rahmat!",
    subtitle:
      "Endi siz RC Group sadoqat dasturi shaxsiy kabinetiga kirishingiz mumkin.",
    moderation:
      "Hozirda sizning yuridik shaxsingiz moderatsiyadan o‘tmoqda. Tekshiruv odatda 24–48 soat davom etadi",
    examination:
      "Tekshiruvdan o‘tish uchun pastdagi tugma orqali hisobni to‘lab, moderatsiyani yakunlang. Hisobni shuningdek, shaxsiy kabinetda: «Mening korxonalarim» - «Hujjatlar» bo‘limida «Test to‘lovi» nomi bilan topishingiz mumkin.",

    goToCabinet: "Kabinetga o‘tish",
    alternativeCheck: {
      button: "Alternativ tekshiruv usuli",
      description:
        "Siz «Anketa-ariza» hujjatini yuklab olib, imzolab, muhr bosib, kompaniyaga yuborishingiz kerak bo‘ladi.",
    },
  },

  alternativePayment: {
    title: "Agar hisobni to‘lash imkoni bo‘lmasa",
    signDocAndSendToMail:
      "Tekshiruvdan o‘tish uchun pastdagi tugma orqali hujjatni yuklab olib imzolash va ushbu sahifaga yuklash yoki <b>hello@rc.city</b> manziliga yuborish kerak",
    whereIsDoc:
      "Hujjatni shaxsiy kabinetingizda ham topishingiz mumkin: «Mening korxonalarim» — «Hujjatlar» bo‘limida «Yuridik shaxsni tasdiqlash - Anketa» nomi bilan",
    downloadFileName: "Anketa-ariza",
    useMainCheckWay: "Asosiy tekshiruv usulini ishlatish",
    paymentInvoice: "To‘lov uchun hisob",
  },
};
